import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="text-xl font-bold text-background-50 font-heading">韩漫大全</span>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              韩国漫画网是热门漫画在线阅读平台，全网韩漫最快更新，涵盖韩漫大全，为您带来极速阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm text-background-100"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm text-background-100"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm text-background-100"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">恋爱漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">动作漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">奇幻漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-mail-line text-xs"></i></span>
                <span>contact@koreanmanhwa.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-phone-line text-xs"></i></span>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-map-pin-line text-xs"></i></span>
                <span>北京市朝阳区望京SOHO T1 1208室</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-5 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 韩国漫画网 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}